var repeatMatcher = (({
  baseGuesses,
  repeatCount
}) => baseGuesses * repeatCount);

export { repeatMatcher as default };
//# sourceMappingURL=scoring.esm.js.map
